import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./TransferActionForm";
import {cancelCancelStockTransfer, successCancelStockTransfer} from "../../../actions/StockTransferApiActions";
import {Map} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "reason");
  return errors.toJS();
}

class CancelStockTransferFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    const data = {
      transferId: this.props.transferId,
      reason: values.get("reason"),
    };
    return this.props.cancelStockTransfer(data)
      .then((response) => {
        if (response.data.cancelStockTransfer.errors.length <= 0) {
          this.props.successCancelStockTransfer();
        } else {
          let errors = createValidationErrors(response.data.cancelStockTransfer.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelCancelStockTransfer();
  }

  render() {
    return (
      <Form
        withReason={true}
        validate={validateForm}
        errors={this.state.errors}
        submitLabel="Cancel Transfer"
        message="Cancel this transfer? If it was already dispatched and drawn down, the stock will be returned to the origin warehouse."
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const CANCEL_STOCK_TRANSFER = gql`
  mutation cancelStockTransfer($data: CancelStockTransferInput!) {
    cancelStockTransfer(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(CANCEL_STOCK_TRANSFER, {
    props: ({ mutate }) => ({
      cancelStockTransfer: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelCancelStockTransfer, successCancelStockTransfer})(withMutation(CancelStockTransferFormContainer));
